import React from 'react';
import contextProvider from '../../contextProvider';

import _ReactOBaseComponent from '../../_L0_components/_ReactOBaseComponent';

import { Parallax } from 'react-parallax';

//import '../.._L1_styles/Layout/section.scss';

class SectionNEW extends _ReactOBaseComponent {
	constructor(props) {
		super(props);
		this.state = {}
	}
	
	onComponentDidMount() {
	//	console.log("DEBUG :: SectionNEW -> onComponentDidMount");
	}
	
	parseImagePath(img_path) {
		if ( /^imgs\./.test(img_path) ) {
			return this.getAppContext().getImagesStoreService().get(img_path);
		} else {
			return img_path;
		}
	}
	
	onRender() {
		let _elemPerRow = this.props.elementsPerRow ? this.props.elementsPerRow : 3;
		let _elemCount = React.Children.toArray(this.props.children).filter((value) => {return value}).length;
		let _calculatedGridSpacing = this.props.gridSpacing ? (this.props.gridSpacing > 1 ? (this.props.gridSpacing / 2) : this.props.gridSpacing) : null;
		
		let _C2 = -1;
		let _mainSection = (
			<span
				className={(this.props.layoutManager == "columns" || this.props.layoutManager == "grid" ? "row no-gutters" : "") + (this.props.VStretch ? ' d-flex align-items-stretch' : '')}
				style={{
					...(this.props.VStretch ? {width: '100%'} : {})
				}}
			>
				
				{React.Children.map(this.props.children, (_C_child, _C_idx) => {
					_C2 = _C2 + (_C_child ? 1 : 0);
					return _C_child ? (
						<span
							className={
								'border-bottom-0 border-right-0 ' + (
									this.props.layoutManager == "columns" ? (
										this.props.columnsDimension ? (
											"col-" + this.props.columnsDimension[_C2]
										) : (
											"col-" + parseInt(12 / (_elemCount || 1))
										)
									) : (
										this.props.layoutManager == "grid" ? "col-" + (12/_elemPerRow) : ""
									)
								) + (
									this.props.VStretch ? ' d-flex align-items-stretch' : ''
								) + (		// First row
									_C2 < _elemPerRow || this.props.layoutManager == "columns" ? ' border-top-0' : ''
								) + (		// First column
									((_C2 % _elemPerRow) == 0 && this.props.layoutManager == "grid") || _C2 == 0 ? ' border-left-0' : ''
								) + (		// Last column
									this.props.gridSpacing > 1 ? (((_C2 % _elemPerRow) == (_elemPerRow - 1) && this.props.layoutManager == "grid") ? ' border-right-0' : '') : ''
								) + (		// Last row
									this.props.gridSpacing > 1 ? ((_C2 + 1) > (_elemCount - (_elemCount % _elemPerRow)) || this.props.layoutManager == "columns" ? ' border-bottom-0' : '') : ''
								)
								
							}
							style={{
								...(this.props.VStretch ? {width: '100%'} : {}),
								...(		// First row
										this.props.gridSpacing > 1 ? (_C2 < _elemPerRow ? {} : {}) : {}
								),
								...(		// First column
									this.props.gridSpacing > 1 ? (((_C2 % _elemPerRow) == 0 && this.props.layoutManager == "grid") || _C2 == 0 ? {} : {}) : {}
								),
								...(		// Last column
									this.props.gridSpacing > 1 ? (((_C2 % _elemPerRow) == (_elemPerRow - 1) && this.props.layoutManager == "grid") ? {} : {}) : {}
								),
								...(		// Last row
									this.props.gridSpacing > 1 ? ((_C2 + 1) > (_elemCount - (_elemCount % _elemPerRow)) ? {} : {}) : {}
								),
								...(this.props.gridSpacing ? {
									borderColor: this.props.gridSpacingColor ? this.props.gridSpacingColor : 'transparent',
									borderWidth: _calculatedGridSpacing + 'px',
									borderStyle: 'solid'
								} : {})
							}}
						>
							<div
								className="w-100 h-100"
							//	style={{
							//		...(!this.props.separationBorder ? {
							//			margin: this.props.gridSpacing + (typeof this.props.gridSpacing == 'number' ? 'px' : ''),
							//			marginRight: '0',
							//			marginBottom: '0',
							//			...( _C2 < _elemPerRow ? {marginTop: '0'} : {}),
							//			...( (_C2 % _elemPerRow) == 0 ? {marginLeft: '0'} : {})
							//		} : {})
							//	}}
							>
								{React.cloneElement(_C_child, {
									..._C_child.props,
									...(this.props.VStretch ? {style: {
										..._C_child.props.style,
										...{width: '100%'}
									}} : {})
								})}
							</div>
						</span>
					) : null;
				})}
				
				{this.props.layoutManager == "grid" && this.props.gridSpacing ? (() => {
					let _TMP_array_count = [];
					for (var i = 0; i < ((_elemCount % _elemPerRow) > 0 ? (_elemPerRow - (_elemCount % _elemPerRow)) : 0); i++) {
						_TMP_array_count.push('__');
					}
					return _TMP_array_count.map((_C_, _C_idx) => {
						return (
							<span
								key={_C_idx}
								className={
									' border-bottom-0 border-right-0' + (_C_idx > 0 ? ' border-left-0' : '') + (
										' col-' + (12/_elemPerRow)
									) + (
										this.props.VStretch ? ' d-flex align-items-stretch' : ''
									) + (
										_elemCount < _elemPerRow ? ' border-top-0' : ''
									)
								}
								style={{
									borderColor: this.props.gridSpacingColor ? this.props.gridSpacingColor : 'transparent',
									borderWidth: _calculatedGridSpacing + 'px',
									borderStyle: 'solid'
								}}
							/>
							
						)
					});
				})() : null}

			</span>
			
		);
		return (
			<section
				id={this.props.id || ""}
				className={"section " + (this.props.className || '') + (this.props.VStretch ? ' d-flex align-items-stretch' : '') + (this.props.backgroundImage ? ' bg-cover' : '') + (this.props.backgroundStyle == 'fixed' ? ' -fixed' : '')}
				style={{
					height: this.props.height ? this.props.height + 'px' : (this.props.VStretch ? '100%' : 'auto'),
					...(this.props.designType != "wide" ? {maxWidth: '1280px', margin: '0 auto'} : {}),
					...(this.props.backgroundImage ? {background: (this.props.backgroundColor ? (this.props.backgroundColor + " ") : "") + "url(" + this.parseImagePath(this.props.backgroundImage) + ") no-repeat " + (this.props.backgroundHAlign || "center") + " " + (this.props.backgroundVAlign || "top")} : {}),
					...(this.props.backgroundColor ? {backgroundColor: this.props.backgroundColor} : {}),
					...(this.props.style || {})
				}}
				onClick={this.props.onClick}
			>

					{this.props.backgroundStyle == 'parallax' ? (
						<Parallax
							className={this.props.VStretch ? 'd-flex align-items-stretch' : ''}
							style={{
								...(this.props.VStretch ? {width: '100%'} : {}),
								...{height: '100%'}
							}}
							blur={this.props.parallaxBlur || 0}
							bgImage={this.parseImagePath(this.props.backgroundImage)}
							bgImageAlt="the cat"
						//	bgWidth="auto"
						//	bgHeight="100%"
							strength={this.props.parallaxStrenght || 200}
						>
							{_mainSection}
						</Parallax>
					) : _mainSection}

			</section>
		);
	}
}

export default contextProvider(
	SectionNEW,
	{
		define: null,
		retrieve: null
	}
);
